// Low-level helpers for the textual encoding of typed ids
// (`<prefix>:<nanoid>`), shared by `utils/id.ts` and `references/ids.ts`.
//
// IMPORTANT: this module must stay import-free. It is reachable from the
// Electron main-process bundle (`src/background.ts` via `utils/navigate.ts`),
// which cannot bundle Vue components — importing anything from
// `src/components/` here breaks `rollup.electron.config.mjs`.

/** The length of the nanoid payload of every typed id. */
export const NANOID_LENGTH = 21;

/**
 * The 21-char nanoid payload of a canonical `<prefix>:<nanoid>` id (e.g.
 * `org:…`, `workspace:…`, `task:…`), or null when the id doesn't have that
 * shape (e.g. event occurrence ids carry an extra date part).
 */
export const nanoidOfPrefixedId = (
  prefix: string,
  id: string
): string | null => {
  const parts = id.split(":");
  return parts.length === 2 &&
    parts[0] === prefix &&
    parts[1].length === NANOID_LENGTH
    ? parts[1]
    : null;
};
